module.exports = __webpack_public_path__ + "img/add-icon.e3fa45cf.svg";